<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header bg-primary">
          <h4 class="card-title text-white mb-0">Optional covers</h4>
        </div>
        <div class="card-body pt-3">
          <div class="row mb-3">
            <div v-for="(item, index) in data.CT_EXTRA_COVER" :key="item.title" class="col-sm-12">
              <div :class="['card cursor-pointer', index === data.CT_EXTRA_COVER.length - 1 ? 'mb-0' : '']" @click="SelectCover(index)">
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-12 d-flex mb-3">
                      <div class="flex-grow-0 flex-shrink-0">
                        <div class="custom-control custom-checkbox custom-checkbox-lg">
                          <input type="checkbox" class="custom-control-input" v-model="item.SELECTED" />
                          <label class="custom-control-label"></label>
                        </div>
                      </div>
                      <div class="flex-grow-1 flex-shrink-1 text-center">
                        <img :src="require(`@/assets/img/${item.IMG}`)" style="height: 40px; width: 40px;" />
                      </div>
                    </div>
                    <div class="col-sm-12 text-center">
                      <h5>{{ item.TITLE }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 d-flex">
              <div class="mr-auto">
                <button type="button" class="btn btn-secondary" @click="previous">Previous</button>
              </div>
              <div class="ml-auto">
                <button type="button" class="btn btn-primary" @click="next">Next</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    lovs: {
      type: Object,
      default: () => {}
    },
  },
  methods: {
    ...mapActions('motor', ['updateValue']),
    SelectCover(index) {
      this.updateValue({ path: `motor.data.CT_EXTRA_COVER[${index}.SELECTED`, value: !this.data.CT_EXTRA_COVER[index].SELECTED });
    },
    next() {
      this.$emit('next');
    },
    previous() {
      this.$emit('previous');
    }
  },
};
</script>
